<mat-drawer-container class="example-container" autosize>
  <mat-drawer #a1 opened="true" class="example-sidenav" mode="side">
    <app-generic [structure]="structure"></app-generic>
  </mat-drawer>
</mat-drawer-container>
